import { createSlice } from 'redux-starter-kit'

import { RESET_ALL_REPORTS } from '../../../common/reportsRedux'

const reduxNamespaceKey = 'profileReport'

const initialState = {
  loadingFilterData: false,
  filterData: {},
  filterDataError: '',
  profileFilterDataReady: false,

  loadingClassProfile: false,
  classProfileData: {},
  classProfileError: '',

  loadingStudentProfile: false,
  studentProfileData: {},
  studentProfileError: '',

  loadingClassEnrollment: false,
  classEnrollmentError: '',
  classDetails: null,
  classStudents: [],
}

const slice = createSlice({
  slice: reduxNamespaceKey,
  initialState: { ...initialState },
  reducers: {
    fetchProfileFilterDataRequest: (state) => {
      state.loadingFilterData = true
      state.profileFilterDataReady = false
    },
    fetchProfileFilterDataSuccess: (state, { payload }) => {
      state.loadingFilterData = false
      state.profileFilterDataReady = true
      state.filterData = payload.filterData
      state.filterDataError = ''
    },
    fetchProfileFilterDataError: (state, { payload }) => {
      state.loadingFilterData = false
      state.profileFilterDataReady = true
      state.filterDataError = payload.error
    },

    fetchClassProfileRequest: (state) => {
      state.loadingClassProfile = true
    },
    fetchClassProfileSuccess: (state, { payload }) => {
      state.loadingClassProfile = false
      state.classProfileData = payload.classProfileData
      state.classProfileError = ''
    },
    fetchClassProfileError: (state, { payload }) => {
      state.loadingClassProfile = false
      state.classProfileData = {}
      state.classProfileError = payload.error
    },

    fetchStudentProfileRequest: (state) => {
      state.loadingStudentProfile = true
    },
    fetchStudentProfileSuccess: (state, { payload }) => {
      state.loadingStudentProfile = false
      state.studentProfileData = payload.studentProfileData
      state.studentProfileError = ''
    },
    fetchStudentProfileError: (state, { payload }) => {
      state.loadingStudentProfile = false
      state.studentProfileData = {}
      state.studentProfileError = payload.error
    },

    fetchClassEnrollmentRequest: (state) => {
      state.loadingClassEnrollment = true
      state.classEnrollmentError = ''
      state.classDetails = null
      state.classStudents = []
    },
    fetchClassEnrollmentSuccess: (state, { payload }) => {
      state.loadingClassEnrollment = false
      state.classDetails = payload.group || null
      state.classStudents = payload.students || []
      state.classEnrollmentError = ''
    },
    fetchClassEnrollmentError: (state, { payload }) => {
      state.loadingClassEnrollment = false
      state.classEnrollmentError = payload.error
      state.classDetails = null
      state.classStudents = []
    },

    resetProfileReport: () => ({ ...initialState }),
  },
  extraReducers: {
    [RESET_ALL_REPORTS]: () => ({ ...initialState }),
  },
})

const { actions, reducer } = slice

export { reduxNamespaceKey, actions, reducer }
